<template>
  <!-- 折线图 -->
  <div :id="ringChartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "RingChart",
  props:["ringChartInfo"],
  data(){
    return {
      // RingChartInfo:{
      //     nodeId:'sexDistribution',//节点
      //     data: [{value: 11.9, name: '女性'},{value: 88.1, name: '男性'},],//数据
      //     color:["#ff5c00","#40a0fc"],
      //     guideline:true
      //     tooltipName:'粉丝总量',
          // unit:'%'
      // }
    }
  },
  computed:{
    
  },
  methods:{
    ringChart(ringChartInfo){
      this.$echarts.dispose(document.getElementById(ringChartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(ringChartInfo.nodeId));
      myChart.setOption({
            tooltip: {//触摸信息
                trigger: 'item',
                formatter: '{b}: {c} '+ringChartInfo.unit,
                confine: true,//浮窗不超出屏幕范围
                textStyle: {
                    fontSize: 12,
                    color: '#333'
                },
                backgroundColor: '#fff',
                borderRadius: 4,  
                axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
                    lineStyle : {          // 直线指示器样式设置
                        color: '#333',
                        width: 0.2,
                        type: 'solid'
                    },
                    z: 2,//竖线在圆圈后面
                },
                extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)'//提示框阴影
            },
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: ['50%', '70%'],//环宽
                    labelLine:{
                        show:true,
                        length:5,
                        length2:5
                    },
                    label: {
                            show: ringChartInfo.guideline,//牵引线
                            position: 'outside',//文字放外部
                            textStyle:{
                                color:"#666"
                            },
                            formatter: '{b}：{d}'+ringChartInfo.unit
                        
                    },
                    itemStyle: { // border
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                    },
                    color:ringChartInfo.color,
                    data: ringChartInfo.data
                }
            ]
        })    
    },
    // ringChart(ringChartInfo){
    //   var myChart = this.$echarts.init(document.getElementById(ringChartInfo.nodeId));
    //   myChart.setOption({
    //         tooltip: {//触摸信息
    //             trigger: 'item',
    //             formatter: '{a} <br/>{b}: {c} %'
    //         },
    //         series: [
    //             {
    //                 name: '访问来源',
    //                 type: 'pie',
    //                 radius: ['50%', '70%'],//环宽
    //                 label: {
    //                     normal: { 
    //                         show: ringChartInfo.guideline,//牵引线
    //                         position: 'outside',//文字放外部
    //                         textStyle:{
    //                             color:"#666"
    //                         },
    //                         formatter: '{b}：{d}%'
    //                     },
    //                 },
    //                 itemStyle: { // border
    //                     normal: {
    //                         borderRadius: 10,
    //                         borderColor: '#fff',
    //                         borderWidth: 2
    //                     },
    //                 },
    //                 color:ringChartInfo.color,
    //                 data: ringChartInfo.data
    //             }
    //         ]
    //     })    
      
      
    // },
    
  },
  components:{
   
  },
  watch:{
    
  },
  mounted() {
    this.ringChart(this.ringChartInfo)
  }
}
</script>

<style scoped>
  

</style>